import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 10l.01 0","key":"svg-1"}],["path",{"d":"M15 10l.01 0","key":"svg-2"}],["path",{"d":"M9.5 15a3.5 3.5 0 0 0 5 0","key":"svg-3"}],["path",{"d":"M12 3a2 2 0 0 0 0 4","key":"svg-4"}]]

const IconMoodKid = createReactComponent('outline', 'mood-kid', 'MoodKid', __iconNode);

export default IconMoodKid;